import { Button, ButtonGroup, Divider } from '@blueprintjs/core'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { defer } from 'lodash'
import React, { useCallback, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import { createUploadType2 } from '../../../../backend/uploadType2/createData'
import { globalOnDemandVars } from '../../../../helper/context'
import { insertStringAtNode, undoManager } from '../../../../helper/functions'
import DialogComp from '../../../commonInterface/dialog'
import InPopover from '../../../commonInterface/inPopover'
import { Type2Or3Item } from '../../../list/uploadType2/class'
import { InsertFormObject } from './forEachInsertForm/insertFormRegister'

const Loading = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
  } else if (pastDelay) {
    return <div css={css`width: 100%; height: 100%; margin: 4px;`} className={'bp3-skeleton'} />
  } else {
    return null
  }
}
const WrapperForLoader = LoadableVisibility({
  // 여기 helper 루트 수정해야함
  loader: () => import('../../../../helper/WrapperForLoader'),
  loading: Loading
})

// -----------------------------------------------------------------------------------------------------------

const getObjectFromContent = (type, currentContentData) => {
  return (
    new Type2Or3Item({
      type: type,
      content: currentContentData,
      isType3: true
    })
  )
}

const uploadFromObject = async (object) => {
  globalOnDemandVars.uploadType2s()[object.id] = object
  await createUploadType2(object.id, {
    type: object.type,
    title: object.title,
    content: object.content,
    timeStamp: object.timeStamp,
    isType3: object.isType3
  })
}

// -----------------------------------------------------------------------------------------------------------

// const RegExpForLastSpace = /\s&/
// const RegExpForFirstSpace = /^\s/

// const getCombinedString = (start, middle, end) => {
//   let newStart = start
//   let newEnd = end
//
//   if (start && !RegExpForLastSpace.test(start)) {
//     newStart = newStart + ' '
//   }
//   if (end && !RegExpForFirstSpace.test(end)) {
//     newEnd = ' ' + newEnd
//   }
//
//   return newStart + middle + newEnd
// }

const getMediaString = (type, id) => {
  return `![${type}](${id})`
}

// -----------------------------------------------------------------------------------------------------------

function UploadInNodes ({ type }) {
  const { t } = useTranslation()
  const TypeObject = useMemo(() => (InsertFormObject[type]), [type])
  const editorRef = useRef(null)
  // -----------------------------------------------------------------------------------------------------------

  const [openModal, setOpenModal] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)
  const [contentData, setContentData] = useState(null)

  const clearCurrentContent = useCallback(
    () => {
      setContentData(null)
      editorRef.current && editorRef.current.clearCurrentEditor()
    },
    []
  )

  // -----------------------------------------------------------------------------------------------------------

  const saveAndUploadCurrentContent = useCallback(
    (isMultiple, currentContentData) => {
      let mediaString
      if (isMultiple) {
        const contentObjectArray = currentContentData.map((oneContentData) => (getObjectFromContent(type, oneContentData)))
        Promise.all(contentObjectArray.map(uploadFromObject))

        mediaString = contentObjectArray.map((object) => (getMediaString(object.type, object.id))).join(' ')
      } else {
        const contentObject = getObjectFromContent(type, currentContentData)
        uploadFromObject(contentObject)

        mediaString = getMediaString(contentObject.type, contentObject.id)
      }

      globalOnDemandVars.set_openNodePopover(true)
      return insertStringAtNode(mediaString)
    },
    [type]
  )

  const saveAndUploadCurrentContent2 = useCallback(
    () => {
      const isMultiple = TypeObject.config && TypeObject.config.multi
      const getCurrentContentDataF = editorRef.current ? (isMultiple ? editorRef.current.getCurrentMultiContentData : editorRef.current.getCurrentContentData) : null

      const result = saveAndUploadCurrentContent(isMultiple, (getCurrentContentDataF ? getCurrentContentDataF() : contentData))
      // -----------------------------------------------------------------------------------------------------------

      if (result === false) {
        return null
      }

      setOpenModal(false)
      clearCurrentContent()
    },
    [TypeObject.config, clearCurrentContent, contentData, saveAndUploadCurrentContent]
  )

  // -----------------------------------------------------------------------------------------------------------

  // const blockHovering = useCallback(
  //   (e) => {
  //     e.preventDefault()
  //     // e.stopImmediatePropagation()
  //     e.stopPropagation()
  //   },
  //   []
  // )

  // -----------------------------------------------------------------------------------------------------------

  return useMemo(() => {
    switch (type) {
      case 'Image':
        return (
          <TypeObject.EditorInNode saveAndUpload={saveAndUploadCurrentContent} />
        )
      default:
        return (
          <>
            {(openModal || openModal2) ? null : (
              <div css={css`width: fit-content; height: fit-content;`}>
                <ButtonGroup css={css`justify-content: flex-end;`} minimal>
                  <Button text={t('Save')} icon={'upload'} onClick={saveAndUploadCurrentContent2} />
                  <Divider />
                  <Button text={t('Open a Rich Editor')} onClick={() => {
                    if (type === 'Drawing') {
                      setContentData(editorRef.current.getCurrentContentData())
                    }
                    setOpenModal(true)
                    setOpenModal2(true)
                  }} />
                </ButtonGroup>
                <TypeObject.EditorInNode contentData={contentData} setContentData={setContentData} ref={editorRef} />
              </div>
            )}
            <DialogComp isOpen={openModal} setDialogOpen={setOpenModal} type={'bigger'} title={(
              <Button text={t('Save')} icon={'upload'} onClick={saveAndUploadCurrentContent2} />)}>
              <div css={css`width: 100%; height: 100%; position: relative; z-index: 10;`}>
                <TypeObject.EditorBig contentData={contentData} setContentData={setContentData} ref={editorRef} />
              </div>
            </DialogComp>
          </>
        )
    }
  }, [contentData, openModal, openModal2, saveAndUploadCurrentContent, saveAndUploadCurrentContent2, t, type])
}

export default UploadInNodes
